class CoachDetails {
  constructor($scope, accountInteractor, loginInteractor, eventsService) {
    this.$scope = $scope;
    this.accountInteractor = accountInteractor;
    this.loginInteractor = loginInteractor;
    this.eventsService = eventsService;
  }

  $onInit() {
    this.name = this.loginInteractor.name;
    this.phone = this.loginInteractor.phone;
  };

  updateDetails() {
    return this.accountInteractor.updateDetails(this.name, this.phone)
      .then(() => {
        this.eventsService.publishSystemMessage('PersonDetailsUpdated');
        this.$scope.$digest();
      }, () => {
        this.eventsService.publishSystemError('Failed to save details');
        this.$scope.$digest();
      });
  }
}

export default {
  name: 'coachDetails',
  obj: {
    controller: CoachDetails,
    controllerAs: '$ctrl',
    template: `
      <header class="component">
          <h2>Profile Details</h2>
      </header>
  
      <form>
          <label for="name">Name</label>
          <input id="name" type="text" ng-model="$ctrl.name">
      
          <label for="phone">Phone</label>
          <input id="phone" type="text" ng-model="$ctrl.phone">
      
          <action-button initial-text="'Save'"
                         type="bordered"
                         action="$ctrl.updateDetails()"></action-button>
      </form>
    `
  }
}